import { useQuery } from '@tanstack/react-query';

import { api } from '~/shared/services/api';

export interface AreaApiItem {
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
  id: string;
  name: string;
  hasActiveRole: boolean;
}

export const useGetAreas = () => {
  return useQuery({
    queryKey: ['areas'],
    queryFn: async (): Promise<AreaApiItem[]> => {
      const { data } = await api.get('/api/user-access-management/areas');
      return data;
    },
    staleTime: 10 * 60 * 1000, // 10 minutos
    cacheTime: 15 * 60 * 1000, // 15 minutos
    refetchOnWindowFocus: false,
    refetchOnMount: true
  });
};
